module.exports = __webpack_public_path__ + "img/comment4.82b77276.png";